import styled from "styled-components";
import { SIDEBAR_PROPS } from "../sidebar-layout.constants";

const SideBarContainer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  width: ${({ isOpen }) =>
    isOpen
      ? SIDEBAR_PROPS.SIDEBAR_OPEN_WIDTH
      : SIDEBAR_PROPS.SIDEBAR_CLOSE_WIDTH};
  z-index: ${({ isOpen }) =>
    SIDEBAR_PROPS.SIDE_BAR_Z_INDEX + (isOpen ? 10 : 0)};
  background-color: ${SIDEBAR_PROPS.SIDEBAR_BACKGROUND_COLOR};
  transition: width 0.5s ease-in-out 0.2s;
  transition-delay: 0.1s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const SideBarLeftContainer = styled(SideBarContainer)`
  left: 0;
  justify-content: space-between;
  &:hover {
    cursor: pointer;
  }
`;

export const SideBarRightContainer = styled(SideBarContainer)`
  right: 0;
`;

export const SideBarContent = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

export const TalentLogo = styled.img`
  margin: 1.5rem;
  height: 1.25rem;
`;
